import { useState } from "react";
import { useBitcoiners } from "@/hooks/use-sheets-data";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAnalytics } from "@/hooks/use-analytics";
import { useScrollNavigation } from "@/hooks/use-scroll";

export function PeopleList() {
  const [currentPage, setCurrentPage] = useState(1);
  const { data: bitcoiners = [], isLoading } = useBitcoiners();
  const { navigateAndScroll } = useScrollNavigation();
  useAnalytics();

  const peoplePerPage = 12;
  const totalPages = Math.ceil(bitcoiners.length / peoplePerPage);
  const currentPeople = bitcoiners.slice(
    (currentPage - 1) * peoplePerPage,
    currentPage * peoplePerPage
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-xl text-muted-foreground">Loading people...</p>
      </div>
    );
  }

  return (
    <div className="-mx-6 -mt-6 min-h-[calc(100vh-4rem)]">
      <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container py-8">
          <h1 className="text-3xl font-bold mb-2">People</h1>
          <p className="text-muted-foreground">
            Browse through our collection of Bitcoin thought leaders
          </p>
        </div>
      </div>

      <div className="container py-8 space-y-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {currentPeople.map((person) => (
            <div
              key={person.id}
              onClick={() => navigateAndScroll(`/people/${person.slug}`)}
              className="cursor-pointer"
            >
              <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow">
                <div className="aspect-square relative bg-muted">
                  {person.avatarUrl ? (
                    <img
                      src={person.avatarUrl}
                      alt={person.name}
                      className="object-cover w-full h-full"
                      loading="lazy"
                      onError={(e) => {
                        console.log('Image failed to load:', {
                          url: person.avatarUrl,
                          person: person.name,
                          message: 'Failed to load image'
                        });
                      }}
                    />
                  ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-muted-foreground">
                      No image
                    </div>
                  )}
                </div>
                <CardContent className="p-4 text-center">
                  <h3 className="font-semibold">{person.name}</h3>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        {totalPages > 1 && (
          <div className="flex justify-center gap-2">
            <Button
              variant="outline"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Previous
            </Button>
            <div className="flex items-center gap-2 px-4">
              <span className="text-sm text-muted-foreground">
                Page {currentPage} of {totalPages}
              </span>
            </div>
            <Button
              variant="outline"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}